// extracted by mini-css-extract-plugin
module.exports = {"items":"SliderSwiper_items__1eRbI","slideSize":"SliderSwiper_slideSize__1c3TR","item":"SliderSwiper_item__2RjNz"};